module.exports = __webpack_public_path__ + "static/media/baywood-dental-group.05ec7ea6.png";